<template>
    <el-form :model="form" ref="form" :rules="rules" :inline-message="true">
        <slot name="head"></slot>
        <el-form-item label="学校域名:" label-width="120px" prop="cor_domain">
            <el-col :span="8">
                <el-input size="mini" v-model="form.cor_domain" @change="handleDomain"><i
                        slot="append">.21zujuan.com</i></el-input>
            </el-col>
            <el-col :span="6" :offset="1">
                <el-button type="text" @click="copyDomain(form.cor_domain)">复制地址</el-button>
            </el-col>
        </el-form-item>
        <el-form-item label="合作机构名称:" label-width="120px" prop="cor_name">
            <el-col :span="5">
                <el-input size="mini" v-model="form.cor_name" @change="handleDataInit"></el-input>
            </el-col>
        </el-form-item>
        <el-form-item label="合作机构Logo:" label-width="120px">
            <el-upload @change="handleDataInit" class="upload-demo" name="contractFile" action="api/order/upload"
                       :headers=headers :on-error="uploadError" :on-success="uploadSuccess" :on-preview="handlePreview"
                       :on-remove="handleRemove" :file-list="form.fileList" :beforeUpload="beforeUpload" :limit="1"
                       list-type="picture">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb(<span style="color:red">只允许上传一张图片</span>)
                </div>
            </el-upload>
        </el-form-item>
        <el-dialog :visible.sync="dialogVisible" :append-to-body='true'>
            <img width="100%" :src="dialogImageUrl" alt>
        </el-dialog>
        <el-form-item label="备注：" label-width="100px" class="limit-configure">
            <el-input style="width: 300px;" type="textarea" v-model="form.memo"
                      @input="emit"></el-input>
        </el-form-item>
    </el-form>
</template>
<script>
    import AttachmentService from "~/services/attachment";
    import CommonService from "~/services/common";

    export default {
        data() {
            var check_domain_url = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请设置合作域名'));
                }
                CommonService.checkUrlIsExist({url: this.form.cor_domain_url, type: '21zujuan.com'}).then(res => {
                    if (res.data.domain_url == this.form.cor_domain_url && res.data.customer_id != this.$route.query['id']) {
                        callback(new Error('合作域名已经存在'));
                    }
                });
            }

            return {
                dialogVisible: false,
                dialogImageUrl: '',
                form: {
                    cor_name: '',
                    cor_domain: '',
                    cor_domain_url: '',
                    fileList: [],
                    memo:''
                },
                rules: {
                    cor_domain: [
                        {required: true, validator: check_domain_url, trigger: 'blur'},
                    ],
                    cor_name: [
                        {required: true, message: '请设置合作机构名称', trigger: 'blur'},
                    ],
                },
                headers: {
                    "access-token": this.$store.getters.token
                }
            };
        },
        mounted() {
            this.form = Object.assign({}, this.params);
            this.form.memo = this.memo
        },
        props: {
            params: {
                type: Object,
                required: true
            },
            memo: {
                type: String,
                required: true
            }
        },
        methods: {

            /**
             * 验证表单
             */
            validateForm(cb) {
                let flag = false;
                this.form = Object.assign({},this.form)
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        flag = valid;
                    }
                    if (typeof cb === 'function') cb(flag)
                    return flag
                });
            },
            handleDomain(val) {
                this.form.cor_domain_url = val + '.21zujuan.com';
                this.$emit("handleDataInit", this.form);
            },
            handleDataInit() {
                this.$emit("handleDataInit", this.form);
            },

            /**@description 图片是上传处理 */
            handleRemove(file, fileList) {
                AttachmentService.del({file_path: file.url}).then(res => {
                    this.form.fileList = [];
                });
            },
            handlePreview(file) {
                this.dialogVisible = true;
                this.dialogImageUrl = file.url;
            },
            uploadSuccess(response, file, fileList) {
                if (response.code > 0) {
                    this.$message({
                        message: response.msg,
                        type: 'error'
                    });
                } else {
                    this.form.fileList = this.form.fileList || [];
                    this.form.fileList.push({"name": response.data.file_name, "url": '/' + response.data.file_path});
                    this.$emit("handleDataInit", this.form);
                }
            },
            uploadError(err, file, fileList) {
                console.log('===');
            },
            beforeUpload(file) {
                let extension = file.name.split('.')[1];
                let filesize = file.size / 1024 / 1024 < 5;
                let type = ['jpg', 'jpeg', 'png'];
                if (!_.includes(type, extension)) {
                    this.$message({
                        message: '上传格式不允许,只允许上传jpg,jpeg,png格式文件',
                        type: 'tips'
                    });
                    return false;
                }

                if (!filesize) {
                    this.$message({
                        message: '上传文件大小不能超过5M',
                        type: 'error'
                    });
                    return false;
                }
            },
            emit() {
                this.$emit('getMemo', this.form);
            },

            copyDomain(domain) {
                const textToCopy = domain + '.21zujuan.com';
                navigator.clipboard.writeText(textToCopy).then(
                    () => this.$message({
                    message: '复制成功',
                    type: 'success'
                    }),
                    () => this.$message({
                    message: '复制失败',
                    type: 'error'
                    })
                );
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/zujuan/initConfigure.vue